module.exports = __webpack_public_path__ + "img/streak40.2ba32950.png";